"use strict";
/*
 * Created on 01 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityAttributeByEntity_1 = require("../model/EntityAttributeByEntity");

var EntityAttributeByEntityConverter_1 = require("./EntityAttributeByEntityConverter");
/**
 * Implementation of {@link EntityAttributeByEntityConverter}.
 *
 * @author JMe
 */


var EntityAttributeByEntityConverterImpl =
/*#__PURE__*/
function (_EntityAttributeByEnt) {
  _inherits(EntityAttributeByEntityConverterImpl, _EntityAttributeByEnt);

  function EntityAttributeByEntityConverterImpl() {
    _classCallCheck(this, EntityAttributeByEntityConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityAttributeByEntityConverterImpl).apply(this, arguments));
  }

  _createClass(EntityAttributeByEntityConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        entityId: conversions.toDocumentReferenceId(source.entityId),
        dataPerEntity: conversions.asObjectArray(source, 'dataPerEntity', function (data) {
          return {
            clazzId: data.clazzId,
            clazzName: data.clazzName,
            attributeId: data.attributeId,
            attributeName: data.attributeName,
            validFrom: conversions.fromDate(data.validFrom),
            validTo: conversions.fromDate(data.validTo)
          };
        })
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new EntityAttributeByEntity_1.EntityAttributeByEntity(EntityAttributeByEntity_1.EntityAttributeByEntity.schema.entityId.valueOf(conversions.toClassReferenceId(source.entityId)), EntityAttributeByEntity_1.EntityAttributeByEntity.schema.dataPerEntity.valueOfField(source));
    }
  }]);

  return EntityAttributeByEntityConverterImpl;
}(EntityAttributeByEntityConverter_1.EntityAttributeByEntityConverter);

exports.EntityAttributeByEntityConverterImpl = EntityAttributeByEntityConverterImpl;